// Geometry only: no product, cart, campaign, pickup or persistent-state changes.
export function mustStackHero({mobile,width,copyHeight,pictureHeight}){
  return mobile&&(width<360||!Number.isFinite(pictureHeight)||pictureHeight<=0||copyHeight>pictureHeight*.38);
}
if(typeof document!=='undefined')for(const hero of document.querySelectorAll('[data-responsive-hero]')){
  const copy=hero.querySelector('[data-hero-copy]'),picture=hero.querySelector('[data-hero-picture]'),img=picture?.querySelector('img');if(!copy||!img)continue;
  const check=()=>{
    // Always measure the same overlay geometry so the fallback cannot oscillate as text rewraps.
    hero.classList.remove('hero-stack');
    const mobile=matchMedia('(max-width:699px)').matches;
    const stack=mustStackHero({mobile,width:hero.getBoundingClientRect().width,copyHeight:copy.getBoundingClientRect().height,pictureHeight:img.getBoundingClientRect().height});
    hero.classList.toggle('hero-stack',stack);
  };
  const observer=new ResizeObserver(check);observer.observe(hero);observer.observe(copy);img.addEventListener('load',check,{once:true});document.fonts?.ready.then(check);check();
}
